import * as React from "react";
import type { SVGProps } from "react";
const SvgHotelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M27.125 18.813h-.437v-3.5a1.753 1.753 0 0 0-1.75-1.75V6.125a1.75 1.75 0 0 0-1.75-1.75H4.813a1.75 1.75 0 0 0-1.75 1.75v7.438a1.75 1.75 0 0 0-1.75 1.75v3.5H.875a.44.44 0 0 0-.437.437V21a.44.44 0 0 0 .437.438h.438v1.75a.44.44 0 0 0 .437.437h1.313a.44.44 0 0 0 .428-.352l.368-1.835H24.14l.368 1.835a.44.44 0 0 0 .428.352h1.313a.44.44 0 0 0 .438-.437v-1.75h.437a.44.44 0 0 0 .438-.438v-1.75a.44.44 0 0 0-.438-.437M3.938 6.124a.876.876 0 0 1 .874-.875h18.376a.876.876 0 0 1 .875.875v7.438h-.875v-1.75a1.753 1.753 0 0 0-1.75-1.75h-5.25a1.753 1.753 0 0 0-1.75 1.75v1.75h-.876v-1.75a1.753 1.753 0 0 0-1.75-1.75h-5.25a1.75 1.75 0 0 0-1.75 1.75v1.75h-.875zm18.375 5.688v1.75h-7v-1.75a.876.876 0 0 1 .874-.876h5.25a.876.876 0 0 1 .875.876m-9.625 0v1.75h-7v-1.75a.876.876 0 0 1 .875-.876h5.25a.876.876 0 0 1 .874.876m-10.5 3.5a.876.876 0 0 1 .874-.876h21.876a.876.876 0 0 1 .875.876v3.5H2.188zm.516 7.437h-.517v-1.312h.78zm23.109 0h-.517l-.262-1.312h.779zm.875-2.187H1.313v-.875h25.375z"
    />
  </svg>
);
export default SvgHotelIcon;
